export function getTranslation(key: string) {
  const translationScript = document.querySelector<HTMLScriptElement>('#order-form-translations');

  if (!translationScript) {
    return key;
  }

  const translations: Record<string, string> = JSON.parse(translationScript.textContent || '{}');
  return decodeHtml(translations[key]) || key;
}

function decodeHtml(str: string): string {
  const txt: HTMLTextAreaElement = document.createElement('textarea');
  txt.innerHTML = str;
  return txt.value;
}
